export default {
	cardProportion: 1.55,
}
